import React from 'react';

function NavBadge({ items }) {
  let navBadges = false;
  if (items.badge) {
    const badgeClass = ['label', 'pcoded-badge', items.badge.type];

    navBadges = (
      <span className={badgeClass.join(' ')}>
        {items.badge.title}
      </span>
    );
  }

  return navBadges;
}

export default NavBadge;
